export const NUMBER_OF_PRIZES = 3;
export const DISCOUNT_AMOUNT = 12;
export const PRIZE_AMOUNT = 4;
export const MAX_PRODUCTS_FOR_GAME = 40;
